import { render } from "./unionSchedule.vue?vue&type=template&id=155c1fa6"
import script from "./unionSchedule.vue?vue&type=script&lang=js"
export * from "./unionSchedule.vue?vue&type=script&lang=js"

import "./unionSchedule.vue?vue&type=style&index=0&id=155c1fa6&lang=css"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "155c1fa6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('155c1fa6', script)) {
    api.reload('155c1fa6', script)
  }
  
  module.hot.accept("./unionSchedule.vue?vue&type=template&id=155c1fa6", () => {
    api.rerender('155c1fa6', render)
  })

}

script.__file = "src/components/unionSchedule.vue"

export default script